import React, { useState, useEffect } from 'react';
import TutorialIndex from './TutorialIndex/TutorialIndex';
import TutorialContent from './TutorialContent/TutorialContent';
import './Tutorial.css';
import TutorialContentSummary from './TutorialModel/TutorialContentSummary';
import TutorialIndexSummary from './TutorialModel/TutorialIndexSummary';
import { useParams } from 'react-router-dom';
import TutorialService from '../../Services/Tutorial/TutorialService';

const Tutorial = () => {
  const { slug } = useParams(); // Get the slug parameter from the URL
  const [tutorialSummary, setTutorialSummary] = useState(new TutorialContentSummary());
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const _TutorialService =new TutorialService();
  useEffect(() => {
    const fetchTutorialData = async () => {
      try {
        
        if (slug) {
          console.log('Fetching tutorial data for slug:', slug);
          var tutorial=await _TutorialService.getTutorial(slug);
          setTutorialSummary(tutorial);
        }

          
        setIsLoading(false);

      } catch (error) {
        console.error("Error while fetching tutorial data:", error);
        setError(error.message);
        setIsLoading(false);
      }
    };

    fetchTutorialData();
  }, [slug]); // Re-run when slug changes

  if (isLoading) {
    return <div className="tutorial-loading">Loading tutorial...</div>;
  }

  if (error) {
    return <div className="tutorial-error">Error loading tutorial: {error}</div>;
  }
  if (!tutorialSummary || !tutorialSummary.TutorialIndexes) {
    return <div className="tutorial-error">No tutorial data available</div>;
  }

  return (
    <div className='tutorial-container'>
      <TutorialIndex TutorialIndexes={tutorialSummary.TutorialIndexes}/>
      <TutorialContent TutorialSections={tutorialSummary.TutorialSections}/>
    </div>
  );
};

export default Tutorial;

